import moment from "moment";
var DateFormatValueConverter = /** @class */ (function () {
    function DateFormatValueConverter() {
    }
    DateFormatValueConverter.prototype.toView = function (value, format, fallback) {
        if (value) {
            return moment(value).format(format ? format : "MMMM Do YYYY");
        }
        else {
            return fallback ? fallback : "";
        }
    };
    return DateFormatValueConverter;
}());
export { DateFormatValueConverter };
